import { IconName } from './components/Icon';
import { ITooltipOption } from './components/KubitTooltip/globalTooltips';
import { PermissionKey } from './utils/apollo/graphqlSchema';

export const appRoutes = {
  dictionary: {
    generateLink: (
      dictionaryType:
        | 'measure'
        | 'cohort'
        | 'event'
        | 'virtual-event'
        | 'field'
        | 'filter'
        | 'buckets',
    ) => `/dictionary/${dictionaryType}`,
    measure: '/dictionary/measure',
    event: '/dictionary/event',
    virtualEvent: '/dictionary/virtual-event',
    field: '/dictionary/field',
    filter: '/dictionary/filter',
    buckets: '/dictionary/buckets',
    routePrefix: '/dictionary',
  },
  schedules: {
    routePrefix: '/schedules',
    dashboard: '/schedules/dashboard',
    report: '/schedules/report',
  },
  report: {
    routePrefix: '/report',
    query: '/report/query',
    funnel: '/report/funnel',
    retention: '/report/retention',
    prediction: '/report/prediction',
    path: '/report/path',
    dataTable: '/report/data-table',
    significance: '/report/significance',
  },
  cohorts: {
    routePrefix: '/cohorts',
    view: '/cohorts/view',
    create: '/cohorts/create',
  },
  permission: {
    routePrefix: '/permission',
    users: '/permission/users',
    allUsers: '/permission/users/all',
    pendingUsers: '/permission/users/pending',
    userGroups: '/permission/user-groups',
    roles: '/permission/roles',
    createUserGroup: '/permission/user-groups/create',
    createRole: '/permission/roles/create',
    settings: '/permission/settings',
    notifications: '/permission/notifications',
    planDetails: '/permission/plan',
  },
  settings: {
    routePrefix: '/settings',
    myProfile: '/settings/my-profile',
    preferences: '/settings/preferences',
  },
  dashboard: {
    routePrefix: '/dash',
    generateLink: (baseId?: string, instanceId?: string) =>
      `/dash${baseId ? `/${baseId}` : ''}${instanceId ? `/${instanceId}` : ''}`,
    generateEmbedLink: (baseId?: string) =>
      `/embed/dash${baseId ? `/${baseId}` : ''}`,
  },
  errorPage: '/error',
  ssoLogin: '/ssologin',
  login: '/login',
  embedLogin: '/embed/login',
  system: '/help/system',
  debug: '/debug',
  incidents: {
    routePrefix: '/incidents',
    manage: '/incidents/manage',
    calendar: '/incidents/calendar',
  },
  workspaces: {
    routePrefix: '/workspaces',
    workspace: (workspaceId: string) => `/workspaces/${workspaceId}`,
  },
  modeler: {
    routePrefix: '/modeler',
    modeler: (schemaKey?: string) =>
      `/modeler${schemaKey ? `/${schemaKey}` : ''}`,
  },
  embed: {
    routePrefix: '/embed',
    report: (reportType: string, reportId: string) =>
      `/embed/report/${reportType}/${reportId}`,
    dashboard: (dashboardBaseId: string, instanceId?: string) =>
      `/embed/dash/${dashboardBaseId}${instanceId ? `/${instanceId}` : ''}`,
    cohort: (cohortId: string) => `/embed/cohorts/create/${cohortId}`,
  },
  home: '/',
};

export enum PermissionUrlAction {
  Edit = 'edit',
  Create = 'create',
}

export interface ISidebarLink {
  title: string;
  url: string;
  icon?: IconName;
  tooltip?: ITooltipOption;
  permissionKeys?: PermissionKey[];
}
